// apps/console/src/services/api/robot-media-events.ts
//
// "A capture from this device was just stored." Mirrors the other robot stores (a module-level
// listener Set, fed by useLiveChannel's fleet mount, so it works on any page with no bridge), but
// holds no state: it is a nudge to re-read the media list, and a panel mounted later already loads
// that list itself — so nothing is replayed on subscribe.

export interface RobotMediaStored {
  robotId: string
  /** What was stored: `image`, `video` or `audio`. Advisory — consumers re-read the list anyway. */
  kind: string
}

type Listener = (event: RobotMediaStored) => void

const listeners = new Set<Listener>()

export function emitRobotMediaStored(event: RobotMediaStored): void {
  if (!event.robotId) return

  listeners.forEach(l => l(event))
}

export function subscribeRobotMediaStored(listener: Listener): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export function __resetRobotMediaEventsForTests(): void {
  listeners.clear()
}
